import { useEffect, useState } from "react";
import FloorBoardDesigner from "@/components/admin/FloorBoardDesigner";
import TableManager from "@/components/admin/TableManager";

/**
 * The floor hub (owner, 2026-10-25): like the menu hub, one place with a page per
 * job — the designer (the board, drag and drop), the tables, and the areas.
 *
 * The tab lives in the hash (`#m/floor/tables`) so a reload or a pasted link lands
 * on the same page (DESIGN.md §11.1). The designer stays mounted while hidden, so
 * an unsaved arrangement survives a look at the Tables page.
 */
const TABS = [
  ["designer", "Floor designer"],
  ["tables", "Tables"],
  ["areas", "Areas"],
];

const tabFromHash = () => {
  // Only the floor module's own hash picks a tab (a settings slug could also be "tables").
  if (!(window.location.hash || "").startsWith("#m/floor")) return "designer";
  const part = (window.location.hash || "").replace(/^#/, "").split("/")[2];
  return TABS.some(([id]) => id === part) ? part : "designer";
};

export default function FloorHub() {
  const [tab, setTab] = useState(tabFromHash);

  useEffect(() => {
    const hash = tab === "designer" ? "#m/floor" : `#m/floor/${tab}`;
    if (window.location.hash !== hash) {
      window.history.replaceState(null, "", `${window.location.pathname}${window.location.search}${hash}`);
    }
  }, [tab]);

  return (
    <div className="space-y-3" data-testid="floor-hub">
      <div className="flex border-b" role="tablist" aria-label="Floor">
        {TABS.map(([id, label]) => (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={tab === id}
            onClick={() => setTab(id)}
            className={`-mb-px flex h-9 items-center border-b-2 px-3 text-body font-medium transition-colors ${
              tab === id ? "border-primary text-primary" : "border-transparent text-muted-foreground hover:text-foreground"
            }`}
            data-testid={`floor-tab-${id}`}
          >
            {label}
          </button>
        ))}
      </div>
      <div hidden={tab !== "designer"}><FloorBoardDesigner active={tab === "designer"} /></div>
      {tab === "tables" && <TableManager view="tables" />}
      {tab === "areas" && <TableManager view="areas" />}
    </div>
  );
}
